import Link from 'next/link';

import { IImage } from 'app/interfaces/common';
import ImageBg from 'app/components/common/ImageBg';

export interface IBranchCardProps {
  image: IImage | null;
  name: string;
  url: string;
}

export default function BranchCard({ image, name, url }: IBranchCardProps) {
  if (!url || !name) return null;
  return (
    <Link
      className="group grid grid-rows-[auto,_auto] xl:grid-cols-12 gap-1.5 md:gap-5 bg-sand"
      href={url}
    >
      <div className="relative xl:col-[7_/_span_6] w-full h-[55vw] md:h-[60vw] xl:h-[32vw] 4xl:h-[calc(1920px_*_0.32)] bg-brown rounded overflow-hidden isolate">
        {!!image?.url && (
          <div className="relative w-full h-full rounded group-hover:scale-105 transition-transform duration-700">
            <ImageBg
              src={image.url}
              alt={image.alt || ''}
              fill
              placeholderDataURL={image.placeholder_data_url}
              className="object-cover rounded"
            />
          </div>
        )}
      </div>
      <div className="xl:col-[4_/_span_3] min-h-13 flex flex-col justify-center pr-28 xl:pr-0 text-h2 md:text-h1 uppercase">
        {name}
      </div>
    </Link>
  );
}
